import { Component } from '@angular/core';

@Component({
  selector: 'app-products-list-empty',
  templateUrl: './products-list-empty.component.html',
  styleUrl: './products-list-empty.component.css'
})
export class ProductsListEmptyComponent {

}
